"use client";
import React from "react";
import Screen from "../components/Screen";
import ProfileHeaderSection from "../components/ProfileHeaderSection";
import HeaderDescription from "../components/HeaderDescription";

import { FowardButton, BackButton } from "../components/forms/DashboardButton";
import HeaderBox from "../components/Box/HeaderBox";
import { mission } from "../components/image";
import { useNavigate } from "react-router-dom";

const Mission = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/value");
  };
  const handlePrev = () => {
    navigate("/about");
  };

  return (
    <div>
      <Screen>
        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Our Team"}
          subsubtext={"Mission & Vison"}
        />
        <p className={`  text-4xl text-lightDark my-4`}>Mission & Vision</p>
        <div className="">
          <HeaderBox text="One Team, One Dream: Building the Future of Healthcare " />
        </div>
        <div className={`  text-black mt-4 text-basetext leading-7 text-left`}>
          We are on a mission to save lives across Africa by delivering
          critical, life-saving supplies such as blood, oxygen, medical samples,
          medical equipment and consumables, PPE, and rare medicines to
          hospitals.
        </div>
        <div className="mt-6 flex w-full flex-col lg:flex-row gap-4">
          <div className="bg-lightDark p-2 rounded lg:w-6/12">
            <p className={`  text-4xl text-white `}>Our Mission</p>
            <img
              src={mission}
              alt="mission"
              className=" rounded-md lg:w-11/12 shadow-lg h-80"
            />
          </div>
          <div className="lg:w-6/12">
            <div>
              <p className={` text-4xl text-black`}>What we aim for!</p>
            </div>
            <div className=" border border-gray  w-full" />

            {data.map((ele: { text: string; title: string }) => {
              return (
                <div
                  key={ele.title}
                  className="flex flex-col px-4 py-1 my-2 hover:bg-[#fbc2c2] rounded transition-all duration-700 cursor-auto"
                >
                  <div className={`lg:text-nowrap text-black text-4xl`}>{ele.title}</div>
                  <div className={` text-black text-md mx-2`}>{ele.text}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="my-2 flex gap-4 w-full justify-end">
          <BackButton
            text={"Previous"}
            onClick={handlePrev}
            subText={"About page"}
          />
          <FowardButton text={"Next"} onClick={handleNext} subText={"Values"} />
        </div>
      </Screen>
    </div>
  );
};

export default Mission;

const data = [
  {
    title: "Company Vision",
    text: "LifeBank's vision is to become Africa's foremost healthcare technology and logistics company.",
  },
  {
    title: "Our Vision for Our People",
    text: "At LifeBank, we are builders. We are a team committed to creating the tech-driven supply chain system to power healthcare across Africa. Our community is diverse, reflective of a dynamic atmosphere that welcomes everyone and asks that you bring your real self to work. We are keen on making a difference across our continent. We believe in working hard to build the business of saving lives. We are LifeBankers!",
  },
  // {
  //   id: "03",
  //   text: "LifeBank is on a mission to save lives across Africa by delivering critical life-saving supplies like blood, oxygen,  medical samples and consumables, PPE and rare medicines to hospitals in Africa using technology and a multi-modal distribution platform",
  //   title: "Dr. John Doe",
  // },
];
